/**
 * **Vila Galé Own System**
 *
 * Example: <a href="http://reservas.vilagale.com/engine/rooms" target="_blank">Vila Galé</a>
 *
 * @exports bs_180
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    let refreshPrice;
    /**
       * @memberOf module:bs_180
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        // NOTE: Return 'pr' when 'br' is found.
        return new Promise(function (resolve, reject) {
            var $ = window.jQuery;
            // Home page language
            var aux = document.getElementsByTagName('body')[0].getAttribute('lang');
            if (aux) {
                aux = aux.toLowerCase();
                if (aux && ctx.langs.test(aux)) {
                    if (aux === 'br') {
                        aux = 'pt';
                    }
                    resolve(aux);
                    return;
                }
            }
            aux = $('.btn--ico-lang.selected').eq(0).attr('class').match(/lang--\w{2}/)[0].substr(6, 2);
            if (aux && ctx.langs.test(aux)) {
                if (aux === 'br') {
                    aux = 'pt';
                }
                resolve(aux);
                return;
            }
            resolve('no-language');
        });
    };
    /**
      * @memberOf module:bs_180
      * @this thn.widgets.price
      * @see {@link Price#observe_dom}
      *
      * @param {object} ctx - The context object.
      */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const calendarContainer = document.querySelector('button.btn.btn--search.border-tlr.no-animate:not(.loading)');
        if (calendarContainer && !refreshPrice) {
            refreshPrice = thn.debounce(() => thn.widgets.price.refresh(), 800);
            thn.observeDom(calendarContainer, refreshPrice, {
                childList: true,
                subtree: true,
                attributes: true,
            });
            thn.pageUnload(() => {
                refreshPrice.cancel();
                thn.stopObserveDom(calendarContainer, refreshPrice);
                refreshPrice = null;
            });
        }
    };
    /**
       * @memberOf module:bs_180
       * @param ctx
       */
    engine.onStateChange = function onStateChange(ctx) {
        setTimeout(function () {
            thn.pageCheck();
            if (thn.widgets.price.isTargetPage()) {
                thn.widgets.price.refresh();
            }
        }, 1000);
    };
    /**
       *
       * Can not implement **no_rooms**. The details are only available the on Calendar page.
       * If no rooms are available, if does not load the Rooms&Rates page.
       *
       * @memberOf module:bs_180
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       *
       * Not implemented yet (using Triptease).
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        // Get the selectors only in the Rooms & Rates page
        if (!thn.widgets.price.isTargetPage()) {
            return widgetData;
        }
        const dates = [...document.querySelectorAll('.list--summary > li:nth-child(2) > p')]
            .map((el) => (el || {}).textContent)
            .filter(Boolean)
            .filter((value, index, self) => self.indexOf(value) === index) // Filtering to avoid repeated values
            .shift() // Get the first element of an array
            .split(' - ');
        let nights;
        if (dates && dates.length > 0) {
            const dateBegin = (dates[0] || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            const dateEnd = (dates[1] || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            if (dateBegin && dateEnd) {
                widgetData.date_begin = dateBegin;
                widgetData.date_end = dateEnd;
                nights = thn.daysBetween(widgetData.date_begin, widgetData.date_end);
            }
        }
        const rooms = [...document.querySelectorAll('.box--tarifas')]
            .map((container) => {
            const info = [...container.querySelectorAll('.box--capacity > i')]
                .map((el) => thn.parseNumber((el || {}).textContent))
                .filter(Boolean);
            const adults = info && info[0] ? info[0] : 2;
            let children = info && info[1] ? info[1] : 0;
            children += info && info[2] ? info[2] : 0;
            const price = [...container.querySelectorAll('.tarifa-price .price')]
                .map((el) => {
                let copyEl;
                // Sometimes a discount inside a span is shown changing the textContent in a way that thn.parseNumber returns a invalid value.
                if (el.querySelector('span')) {
                    copyEl = el.cloneNode(true);
                    copyEl.querySelector('span')?.remove(); // Remove the invalid price
                }
                return thn.parseNumber((copyEl || el)?.textContent);
            })
                .filter(Boolean)
                .shift(); // Return the first element of an array
            if (price) {
                return { adults, price, children };
            }
            return false;
        })
            .filter(Boolean)
            .sort((a, b) => a.price - b.price);
        const currency = (((document.querySelector('.price-refundable') && document.querySelector('.price-refundable').childNodes[2]) || {}).textContent || '').trim();
        if (rooms && rooms.length) {
            widgetData.adults = rooms[0].adults;
            widgetData.children = rooms[0].children;
            widgetData.guests = widgetData.adults + widgetData.children;
            // Prices & Currency || No Rooms
            if (rooms[0].price && nights) {
                widgetData.price = rooms[0].price;
                widgetData.currency = thn.parseCurrency(currency);
                widgetData.set = true;
            }
        }
        else {
            const calendarEl = document.querySelector('button.btn.btn--search.border-tlr.no-animate:not(.loading)');
            if (calendarEl && document.querySelector('.box--feedback:not(.hide)')) {
                widgetData.no_rooms = true;
            }
        }
        return widgetData;
    };
    /**
       * Implements **booking_id**.
       *
       * @memberOf module:bs_178
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        if (!$) {
            return widgetData;
        }
        const bookingInformation = $('.box--summary-reservation li p:nth-child(2)');
        if (bookingInformation.length > 4) {
            widgetData.booking_id = (bookingInformation[1] || {}).innerText;
            const dates = ((bookingInformation[3] || {}).innerText || '').match(/(\d+)\D+(\d+)\D+(\d+)/g);
            if (dates && dates.length) {
                const dateBegin = (dates[0] || '').replace('-', '/').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                const dateEnd = (dates[1] || '').replace('-', '/').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                widgetData.date_begin = dateBegin;
                widgetData.date_end = dateEnd;
            }
            const adultsChildren = ((bookingInformation[4] || {}).innerText || '').match(/\d/g);
            if (adultsChildren) {
                widgetData.adults = adultsChildren.length > 0 ? thn.parseNumber(adultsChildren[0]) : 2;
                widgetData.children = adultsChildren.length > 1 ? thn.parseNumber(adultsChildren[1]) : 2;
            }
        }
        widgetData.price = thn.parseNumber($('.box--summary-price .total').text());
        widgetData.currency = 'EUR';
        return widgetData;
    };
    return engine;
}

export { factory };
